import {
  createComponentMapperModel,
  withCompInfo,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type {
  IResponsivePopupContainerProps,
  IResponsivePopupContainerStateRefsValues,
} from '../ResponsivePopupContainer.types';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';

export const props = withCompInfo<
  IResponsivePopupContainerProps,
  any, // There is no ResponsivePopupContainerDefinition in TB Components
  IResponsivePopupContainerProps
>()(['experiments'], ({ experiments }, carmiData) => {
  const isDisableDocumentScrollWhenLightBoxOpenExperimentOpen =
    isExperimentOpen(
      experiments,
      'specs.thunderbolt.DisableDocumentScrollWhenLightBoxOpen',
    );

  return {
    ...carmiData,
    isDisableDocumentScrollWhenLightBoxOpenExperimentOpen,
  };
});

export const stateRefs = withStateRefsValues<
  keyof IResponsivePopupContainerStateRefsValues
>(['setSiteScrollingBlocked']);

export default createComponentMapperModel({ props, stateRefs });
